export default __webpack_public_path__ + "static/media/Drone1 (2).42dc40f7.jpg";